/**
 * /*
 * $Id$
 * ih.form
 *
 * Namespace to hold form related functionality - mostly pertaining to validation
 *
 * The goal with validation is to leverage the native HTML5 properties, attributes, and logic
 * as much as possible while rolling our own display layer.
 *
 *
 * -------------------------------
 * USAGE
 * -------------------------------
 *
 *
 *
 * ih.form.validateInput(input);
 *
 * @format
 */

var ih = ih || {};

(function ($) {
    ih.form = {
        // returns a validity property for an input that is always valid
        fakeValidity: function () {
            return {
                valid: true,
                valueMissing: false,
                typeMismatch: false,
                patternMismatch: false,
                // there are some other values here that we don't care about

                // Until we do... here they are for reference.
                // badInput: false
                // customError: false
                // patternMismatch: false
                // rangeOverflow: false
                // rangeUnderflow: false
                // stepMismatch: false
                // tooLong: false
                // tooShort: false
                // typeMismatch: false
                // valid: true
                // valueMissing: false
            };
        },

        // takes an input (by reference) and sets up it's validity object.
        checkValidity: function (input, options) {
            // native html5 validation is available
            if (typeof input.willValidate !== "undefined") {
                // this input type is not supported. always valid for now.
                if (
                    input.nodeName === "INPUT" &&
                    input.type !== input.getAttribute("type")
                ) {
                    // can't do this - this property is readonly
                    // input.validity = ih.form.fakeValidity(input);
                    return ih.form.fakeValidity(input);
                }

                // native browser check, sets the values for the validity property on the input
                input.checkValidity();

                // console.log("input.validity", input.validity);

                // option to ignore the stepMismatch validation error.
                // This allows the arrow keys to use the increment/decrement
                // by that step value AND allow valid values to be manually
                // entered that aren't dividible by that step value.
                if (
                    options &&
                    options.ignoreStepMismatch &&
                    !input.validity.valid &&
                    input.validity.stepMismatch &&
                    !input.validity.badInput &&
                    !input.validity.customError &&
                    !input.validity.patternMismatch &&
                    !input.validity.rangeOverflow &&
                    !input.validity.rangeUnderflow &&
                    !input.validity.tooLong &&
                    !input.validity.tooShort &&
                    !input.validity.typeMismatch &&
                    !input.validity.valueMissing
                ) {
                    // this will not work.
                    // input.validity is a read only property
                    // input.validity.stepMismatch = false;
                    // input.validity.valid = true;

                    return ih.form.fakeValidity(input);
                }
            } else {
                return ih.form.fakeValidity(input);
            }

            return input.validity;
        },

        // validates a DOM input, setting its validity property,
        // handles setting and removing styling and messaging for any validation errors
        // you can use the second and third params to force it to be valid or not and to set a custom error message
        // returns true/false for if valid or not, with side effects of error UI handling.
        validateInput: function (input, valid, message) {
            var $input = $(input);
            var $field = $input.closest(".field, .ih-modal-field");

            // thin wrapper around the native html5 validity check.
            // we need to make a few exceptions and tweaks.
            // builds up the input.validity object.

            // by default, ignore any stepMismatch validation errors
            var options = { ignoreStepMismatch: true };
            var validity = ih.form.checkValidity(input, options);
            // input.validity = ih.form.checkValidity(input);

            // field is valid
            // TODO: ?? this logic doesn't match the above description:
            // "you can use the second and third params to force it to be valid or not"
            if (validity.valid && valid !== false) {
                $field.removeClass("has-error ih-has-error");
                $input.removeClass("has-error ih-has-error");
                $field.find(".error").text("").hide();
                return true;
            } else {
                $field.addClass("has-error ih-has-error");
                $input.addClass("has-error ih-has-error");

                if ($field.length) {
                    var $error = $field.find(".error, .ih-error");
                    if (!$error.length) {
                        $error = $("<div>")
                            .addClass("error ih-error")
                            .appendTo($field); //.insertAfter(input);
                    }

                    // default
                    var errorMessage = ih.form.validationMessage(input);

                    // always use an explicit message in the params (usually from the server)
                    if (message !== undefined) {
                        errorMessage = message;
                    }
                    // else if the error already has text, use it.
                    else if ($error.text()) {
                        errorMessage = $error.text();
                    }

                    $error.text(errorMessage).show();
                }
                return false;
            }
        },

        validateRecaptcha: function (form) {
            var $recaptcha = $(form).find(".g-recaptcha");
            if (!$recaptcha.length) {
                //                console.log("there is no recaptcha to validate.");
                return true;
            }

            //console.log("validateRecaptcha()", $recaptcha);

            // if we don't already have a value...
            var $field = $recaptcha.find(".g-recaptcha-response");
            // console.log($field);

            if ($field.val() == "") {
                // console.log("field value is empty");

                var recaptchaId = $(form).data("recaptchaid");
                // console.log("captcha is empty. execute!");
                window.grecaptcha.execute(recaptchaId);
                return false;

                // callback will populate value and resubmit the form
            } else {
                // console.log("captcha already has a value. assume valid");
                return true;
            }
        },

        // validates all the fields in a form, calling validateInput on each one
        // handles setting and removing styling and messaging for any validation errors
        // returns boolean for if the form is valid
        validate: function (form) {
            //            console.log("validate()");

            var $form = $(form);
            var $inputs = $form.find("input, select, textarea");

            var valid = true;

            $inputs.each(function () {
                if (!ih.form.validateInput(this)) {
                    valid = false;

                    // console.log("invalid field:", this);
                }
            });

            // if all other fields are valid, and if there is a captcha, check it now
            if (valid) {
                // console.log("all regular fields are valid");

                if (!ih.form.validateRecaptcha(form)) {
                    valid = false;
                }
            }

            if (!valid) {
                $(document).trigger("trackingEvent", {
                    category: "lead",
                    action: "form_error",
                    label: $form.attr("name"),
                });
            }

            //            console.log("isValid?", valid);

            return valid;
        },
        // returns a validation error message for a given input
        // or an empty string if the input is valid
        validationMessage: function (input) {
            if (input.validity.valid) return "";

            var message = "Please enter a valid value";
            if ($(input).attr("type") == "checkbox") {
                message = "This checkbox is required";
            }

            // allow for custom messages to be used via data attributes on the input
            // if (input.validity.valueMissing) {
            // }
            var valueMissingMessage = $(input).data("value-missing-message");
            if (valueMissingMessage) {
                message = valueMissingMessage;
            }
            return message;
        },

        // Attaches default validation events to a form and its inputs.
        attachValidationEvents: function (form, delay) {
            //            console.log("attach validation events", form);

            // an array of matching form elements
            var $form = $(form);
            //            console.log("How many form elements", $form.length);

            // Disallow the native html5 validation messages on the form
            // However, we WILL be using the native html5 validation attributes and properties
            // to roll our own ui instead
            $form.attr("novalidate", true);

            // validate the entire form on submit

            $form.on("submit", function (e) {
                var $formInstance = $(this); // just this instance
                // console.log("$formInstance", $formInstance);

                // block double form submissions
                // if already posting, do nothing.
                if (
                    $formInstance.is(".posting") &&
                    !$formInstance.is(".delayed-post")
                ) {
                    // console.log("form is already posting. bail!");
                    return false;
                }

                $formInstance.addClass("posting");

                // If validation fails, block the submit event
                if (!ih.form.validate($formInstance[0])) {
                    e.preventDefault();
                    //                    console.log("validation failed!");

                    // scroll the page to the first field and THEN focus it.
                    // (if you focus it first, the page jumps to it immediately and screws up the animation)
                    var $firstError = $formInstance
                        .find(".has-error, .ih-has-error")
                        .first();

                    if ($firstError.length) {
                        $(ih.scrollTopElement).animate(
                            { scrollTop: $firstError.offset().top - 100 },
                            500,
                            function () {
                                $firstError.focus();
                            }
                        );
                        ih.error("Oops! There were problems.", {
                            autoClose: 2,
                        });
                    }

                    $formInstance.removeClass("posting delayed-post");
                }
                // else if form post worked, we'll be on a new page
                // (ajax posts will have to manually remove the .posting class
                // if they want to be able to resubmit the form.
                else {
                    // if we're delaying the actual post to allow for css animations
                    // delay in ms
                    if (delay && !$formInstance.is(".delayed-post")) {
                        //                        console.log("there is a delay. block the post, then after a delay of " + delay + " ms repost.");
                        e.preventDefault();

                        setTimeout(function () {
                            $formInstance.addClass("delayed-post").submit();
                        }, delay);
                    }
                }
            });

            // validate inputs whenever they change
            $form.on("change", "input, select, textarea", function () {
                ih.form.validateInput(this);
            });

            // don't use the blur event to fire validation checks until the form has been interacted with.
            // this way, validation won't fire in the case of opening and then immediately closing a form
            $form.one("click keyup", "input, select, textarea", function (e) {
                var $formInstance = $(this).closest("form"); // just this instance

                // exception is when tabbing out of the first input that gets focused by default
                if (e.keyCode == 9) {
                    var firstField = $formInstance
                        .find("input, select, textarea")
                        .not("[type=hidden]")[0];
                    ih.form.validateInput(firstField);
                }
                $formInstance.on(
                    "blur",
                    "input, select, textarea",
                    function () {
                        ih.form.validateInput(this);
                    }
                );
            });
        },

        // Form Builder
        builder: {
            // Create passed fields
            buildFormFields: function (fields, $container, name) {
                $.each(fields, function (i) {
                    // a type is required
                    if (!this.type) {
                        console.error("You must provide a type property!");
                        return;
                    }

                    // if it's a fieldset, call recursively to build it's fields
                    if (this.type == "fieldset") {
                        ih.form.builder.buildFormFieldset(this, $container);
                    } else {
                        ih.form.builder.buildFormField(
                            i,
                            this,
                            $container,
                            name
                        );
                    }
                });

                return this;
            },

            // Create a fieldset
            buildFormFieldset: function (params, $container) {
                var $fieldset = $(ih.form.templates.fieldset);

                if (params.legend) {
                    $(ih.form.templates.legend)
                        .html(params.legend)
                        .appendTo($fieldset);
                }

                if (params.fields && params.fields.length) {
                    ih.form.builder.buildFormFields(params.fields, $fieldset);
                }

                $fieldset.appendTo($container);

                return this;
            },

            // Create a field and add it to a form
            buildFormField: function (index, params, $container, name) {
                // console.log("buildFormField: index", index);
                // console.log("buildFormField: params", params);

                var $field;
                var $input = ih.form.builder.buildFormInput(params);
                var $label = ih.form.builder.buildFormInputLabel(params);

                // generate a name if it is missing.
                if (!params.name) {
                    params.name = params.type + index;
                }
                // call a specific for a type function (if exists) before any manipulations with a field
                if (
                    $.isFunction(
                        ih.form.builder["prePopulateField_" + params.type]
                    )
                ) {
                    ih.form.builder["prePopulateField_" + params.type](
                        params,
                        $input,
                        $label
                    );
                }

                // set input's attributes, parameters, values and so on
                ih.form.builder
                    .setFormInputAttributes(params, $input)
                    .setFormInputValue(params, $input);

                // call a specific for a type render function or the default one
                if (
                    $.isFunction(
                        ih.form.builder["renderFormField_" + params.type]
                    )
                ) {
                    $field = ih.form.builder["renderFormField_" + params.type](
                        params,
                        $input,
                        $label
                    );
                } else {
                    $field = ih.form.builder.renderFormField(
                        params,
                        $input,
                        $label
                    );
                }

                // add a field to the container
                $field.appendTo($container);

                // call a specific for a type function (if exists) after a field was created
                if (
                    $.isFunction(
                        ih.form.builder["postCreateField_" + params.type]
                    )
                ) {
                    ih.form.builder["postCreateField_" + params.type](
                        params,
                        $field,
                        $container,
                        name
                    );
                }

                return this;
            },

            // Create a jQuery object for an input
            buildFormInput: function (params) {
                if (params.type == "html") {
                    return $(params.html);
                    //                    return $('<p>'+params.html+'</p');
                    //                    return $('<div>'+params.html+'</div');
                }

                // If we have a template for this type, use it.
                if (ih.form.templates.inputs[params.type]) {
                    var formInput = "";
                    var baseValue = ih.form.templates.inputs[params.type];
                    var vals, values, i;

                    switch (params.type) {
                        case "radio":
                            // there are multiple radios, one for each option.
                            values = String(params.options);
                            if (values && values.length > 0) {
                                vals = values.split(/,\s*/);
                                for (i = 0; i < vals.length; i++) {
                                    formInput +=
                                        "<label>" +
                                        baseValue.replace("@@", vals[i]) +
                                        " " +
                                        vals[i] +
                                        "</label><br />\n";
                                }
                            }
                            break;

                        case "checkbox":
                            //formInput += "<label>" + baseValue + " " + params.label + "</label><br />\n";
                            formInput +=
                                "<label>" + baseValue + "</label>&nbsp;";
                            break;

                        case "checkboxes":
                            // there are multiple checkboxes, one for each option.
                            values = String(params.options);
                            if (values && values.length > 0) {
                                vals = values.split(/,\s*/);
                                for (i = 0; i < vals.length; i++) {
                                    //formInput += "<label>" + baseValue.replace("@@", vals[i]) + " " + vals[i] + "</label><br />\n";
                                    formInput +=
                                        "<label>" +
                                        baseValue +
                                        " " +
                                        vals[i] +
                                        "</label><br />\n";
                                }
                            }
                            break;

                        default:
                            // simple text
                            formInput = ih.form.templates.inputs[params.type];
                            break;
                    } // end switch

                    return $(formInput);
                } // end if there is a type

                // no template for this value, just return the type.
                return $("<input>").attr("type", params.type);
            },

            // Create a jQuery object for a label
            buildFormInputLabel: function (params) {
                if (!params.label) {
                    return false;
                }

                var $label = $(ih.form.templates.label).text(params.label);
                if (params.required) {
                    $(ih.form.templates.required).appendTo($label);
                }
                if (params.labelHint) {
                    $(ih.form.templates.labelHint)
                        .html(" " + params.labelHint)
                        .appendTo($label);
                }

                return $label;
            },

            // build the options for a select using an options array
            // you can use a flat array like ["apples", "oranges", "bananas"]
            // or an array of objects like [{ label:"Apples", value:"101" }, { label:"Oranges", value:"102" }, { label:"Bananas", value:"103" }]
            // or an object like {101: "Apples", 102: "Oranges", 103: "Bananas"}
            buildOptions: function (options) {
                var optionsHTML = "";

                var isArray = $.isArray(options);

                // loop through options (array items or object properties)
                $.each(options, function (key, option) {
                    // default handles object case
                    var value = key;
                    var label = option;

                    if (isArray) {
                        if (typeof option === "string") {
                            value = option;
                        } else if (typeof option === "object") {
                            value = option.value;
                            label = option.label;
                        }
                        //                        else {
                        //                            throw "select option is invalid";
                        //                        }
                    }

                    optionsHTML +=
                        '<option value="' +
                        value +
                        '">' +
                        label +
                        "</option>\n";
                });

                return $(optionsHTML);
            },

            // Set input attributes
            setFormInputAttributes: function (params, $input) {
                // append any extra class names/string to our own
                if (params["class"]) {
                    $input.addClass(params["class"]);
                }

                // properties: disabled, required, checked
                $.each(["disabled", "required", "checked"], function () {
                    $input.prop(this, !!params[this]);
                });

                // map the non-special properties as attributes
                var specialProperties = [
                    "type",
                    "class",
                    "disabled",
                    "required",
                    "checked",
                    "label",
                    "value",
                    "options",
                    "html",
                    "update",
                ];
                /* eslint-disable no-unused-vars */
                $.each(params, function (key, val) {
                    if (specialProperties.indexOf(key) == -1) {
                        if (key == "name" && params.type == "checkboxes") {
                            var $checkboxes = $input
                                .filter("label")
                                .children(".ih-modal-checkbox")
                                .each(function (idx, element) {
                                    $(this).attr(
                                        "name",
                                        params.name + "[" + idx + "]"
                                    );
                                });
                        }
                        if (key == "name" && params.type == "checkbox") {
                            var $checkbox = $input
                                .filter("label")
                                .children(".ih-modal-checkbox")
                                .each(function (idx, element) {
                                    $(this).attr("name", params.name);
                                });
                        } else if (key == "name" && params.type == "radio") {
                            var $radios = $input
                                .filter("label")
                                .children(".ih-modal-radio")
                                .each(function (idx, element) {
                                    $(this).attr("name", params.name);
                                });
                        } else if (key == "name" && params.type == "html") {
                            // we'll do something here eventually. maybe
                        } else {
                            $input.attr(key, val);
                        }
                    }
                });
                /* eslint-enable no-unused-vars */

                return this;
            },

            // Set an input value
            setFormInputValue: function (params, $input) {
                // make sure that we've populated options by now or else this won't work for a select box
                if (params.value) {
                    $input.val(params.value);
                }

                return this;
            },

            // Default form field renderer
            renderFormField: function (params, $input, $label) {
                var $field = $(ih.form.templates.field);

                if ($label) {
                    $field.append($label).append("<br />");
                }

                return $field.append($input);
            },

            // Add options to a select
            prePopulateField_select: function (params, $input) {
                if (params.options) {
                    $input.append(ih.form.builder.buildOptions(params.options));
                }

                return this;
            },

            // Prepare attributes for recaptcha
            prePopulateField_recaptcha: function (params) {
                params.id = params.name + "_" + Date.now();

                return this;
            },

            // Render a field for checkbox
            renderFormField_checkbox: function (params, $input, $label) {
                var $field = $(ih.form.templates.field);

                if ($label) {
                    $input = $label.prepend($input);
                }

                return $field.append($input);
            },

            // Create a recaptcha widget and set a method to update it after
            // each time a form's sent
            /* eslint-disable no-unused-vars */
            postCreateField_recaptcha: function (
                params,
                $field,
                $container,
                name
            ) {
                $field.addClass("recaptcha_field");

                var $actual_recaptcha_div = $($field.children()[0]);

                $actual_recaptcha_div.attr(
                    "data-sitekey",
                    ih.data.recaptcha.invisiblePublicKey
                );
                $actual_recaptcha_div.attr("data-badge", "inline");
                $actual_recaptcha_div.attr("data-size", "invisible");
                //console.log("done recaptcha data, ", $actual_recaptcha_div);
            },
            /* eslint-enable no-unused-vars */
        },

        // Google reCAPTCHA widget
        reCaptcha: {
            render: function (form) {
                // console.log( "reCaptcha.render, form: ", form );
                var $recaptchaDiv = form.find("div.recaptcha_field");
                var $recaptchaField = $recaptchaDiv.children()[0]; //'.g-re-invisible-captcha-placeholder'

                if ($recaptchaField !== undefined) {
                    var $captcha_id = window.grecaptcha.render(
                        $recaptchaField,
                        {
                            sitekey: ih.data.recaptcha.invisiblePublicKey,
                            callback: function (token) {
                                ih.form.reCaptcha._captcha_callback(
                                    form,
                                    token
                                );
                            },
                        }
                    );

                    // save this ID in the form itself
                    form.data("recaptchaid", $captcha_id);
                }
            },

            execute: function (form, callback) {
                // console.log( "reCaptcha.execute " );

                // var $recaptcha_div = form.find("div.recaptcha_field");
                var $recaptcha_id = form.data("recaptchaid");

                // save the callback in the form itself
                form.data("recaptcha_callback", callback);

                // execute the recaptcha
                window.grecaptcha.execute($recaptcha_id);
            },

            formFailed: function (form) {
                // console.log( "reCaptcha.formFailed " );

                // var $recaptcha_div = form.find("div.recaptcha_field");
                var $recaptcha_id = form.data("recaptchaid");

                window.grecaptcha.reset($recaptcha_id);
            },

            // The callback to use for grecaptcha
            // eslint-disable-next-line no-unused-vars
            _captcha_callback: function (form, token) {
                // console.log("_captcha_callback");

                // get the form callback from the form, and execute it
                var $callback_function = form.data("recaptcha_callback");

                $callback_function("confirm");
            },
        }, // end reCaptcha

        // form's templates
        templates: {
            form:
                "<form class='ih-modal-content ih-modal-form'>" +
                "<div class='ih-modal-body'>" +
                "<div class='ih-modal-message'></div>" +
                "</div>" +
                "</form>",
            formContent: "<div class='ih-modal-form-content'></div>",
            fieldset: "<fieldset class='ih-modal-fieldset'></fieldset>",
            field: "<div class='ih-modal-field'></div>",
            legend: "<legend class='ih-modal-legend'></legend>",
            label: "<label></label>",
            labelHint: "<span class='ih-label-hint'></span>",
            required: "<span class='ih-required'>*</span>",
            inputs: {
                text:
                    "<input type='text' class='ih-modal-input ih-modal-input-text' autocomplete='off'>",
                password:
                    "<input type='password' class='ih-modal-input ih-modal-input-text' autocomplete='off'>",
                hidden:
                    "<input type='hidden' class='ih-modal-input ih-modal-input-hidden' autocomplete='off'>",
                textarea:
                    "<textarea class='ih-modal-input ih-modal-input-textarea'></textarea>",
                select:
                    "<select class='ih-modal-input ih-modal-input-select'></select>",
                checkbox:
                    "<input type='checkbox' class='ih-modal-input ih-modal-checkbox' value='Y'>",
                checkboxes:
                    "<input type='checkbox' class='ih-modal-input ih-modal-checkbox' value='Y'>",
                radio:
                    "<input type='radio' class='ih-modal-input ih-modal-radio' value='@@'>",
                recaptcha: "<div></div>",
                html: "",
            },
        },
    };

    //    ih.form.reCaptcha.render();
})(window.jQuery);
